import EditorEmbedUploadFile from "@components/editor/plugins/embeds/EditorEmbedUploadFile"
import {
  DecoratorBlockNode,
  SerializedDecoratorBlockNode,
} from "@lexical/react/LexicalDecoratorBlockNode"
import { ElementFormatType, LexicalNode, NodeKey, Spread } from "lexical"

export interface EmbedUploadFilePayload {
  key?: NodeKey
  file: File
}

export type SerializedEmbedUploadFileNode = Spread<
  {
    file: File
  },
  SerializedDecoratorBlockNode
>

export class EmbedUploadFileNode extends DecoratorBlockNode {
  __file: File

  static getType(): string {
    return "embed-upload-file"
  }

  static clone(node: EmbedUploadFileNode): EmbedUploadFileNode {
    return new EmbedUploadFileNode(node.__file, node.__key)
  }

  static importJSON(serializedNode: SerializedEmbedUploadFileNode): EmbedUploadFileNode {
    const { file } = serializedNode
    const node = $createEmbedUploadFileNode({ file })
    return node
  }

  constructor(file: File, key?: NodeKey, format?: ElementFormatType) {
    super(format, key)
    this.__file = file
  }

  exportJSON(): SerializedEmbedUploadFileNode {
    return {
      ...super.exportJSON(),
      version: 1,
      type: "embed-upload-file",
      file: this.getFile(),
    }
  }

  // View
  updateDOM(): false {
    return false
  }

  getFile(): File {
    return this.__file
  }

  decorate(): JSX.Element {
    return <EditorEmbedUploadFile nodeKey={this.getKey()} file={this.__file} />
  }
}

export function $createEmbedUploadFileNode({
  file,
  key,
}: EmbedUploadFilePayload): EmbedUploadFileNode {
  return new EmbedUploadFileNode(file, key)
}

export function $isEmbedUploadFileNode(
  node: LexicalNode | null | undefined
): node is EmbedUploadFileNode {
  return node instanceof EmbedUploadFileNode
}
